import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelRadio as _vModelRadio, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48803bb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "solid my-4" }, null, -1));
const _hoisted_2 = { class: "distribution-rule" };
const _hoisted_3 = { class: "section-title" };
const _hoisted_4 = { class: "required" };
const _hoisted_5 = { class: "distribution-rule__container" };
const _hoisted_6 = { for: "seller-1" };
const _hoisted_7 = { class: "distribution-rule__container" };
const _hoisted_8 = { for: "seller-2" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsManagementDistributionRule',
    setup(__props) {
        const store = useStore();
        const automaticAction = computed(() => store.state.campaignsManagement.automaticAction);
        const tooltipEmptyError = computed(() => store.state.campaignsManagement.tooltipEmptyError);
        const computedSellerAllocation = computed({
            get: () => {
                return automaticAction.value.sellerAllocation;
            },
            set: newValue => {
                store.dispatch('campaignsManagement/setAutomaticAction', { name: 'sellerAllocation', value: newValue });
            },
        });
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.label-rule')) + " ", 1),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createTextVNode("*")
                        ])), [
                            [
                                _directive_tooltip,
                                {
                                    theme: 'error',
                                    html: true,
                                    autoHide: false,
                                    distance: 8,
                                    content: _ctx.$t('campaigns.required-section'),
                                    shown: automaticAction.value.sellerAllocation === null && tooltipEmptyError.value.sellerAllocation,
                                },
                                void 0,
                                { right: true }
                            ]
                        ])
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('360.campaigns.details.text-rule')), 1),
                    _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: 0,
                            name: "seller",
                            id: "seller-1",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedSellerAllocation).value = $event))
                        }, null, 512), [
                            [_vModelRadio, computedSellerAllocation.value]
                        ]),
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('360.campaigns.details.rules.preference')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: 1,
                            name: "seller",
                            id: "seller-2",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((computedSellerAllocation).value = $event))
                        }, null, 512), [
                            [_vModelRadio, computedSellerAllocation.value]
                        ]),
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('360.campaigns.details.rules.seller')), 1)
                    ])
                ])
            ], 64));
        };
    }
});
